module.exports = __webpack_public_path__ + "img/badge-list-thumb-062.cf8a0fde.png";